const PEER_COLORS: ReadonlyArray<readonly [string, string]> = [
  ['#FF885E', '#FF516A'],
  ['#FFCD6A', '#FFA85C'],
  ['#E0A2F3', '#D669ED'],
  ['#A0DE7E', '#54CB68'],
  ['#53EDD6', '#28C9B7'],
  ['#72D5FD', '#2A9EF1'],
  ['#FFA8B4', '#FF77B5'],
];

function hashKey(key: string | number): number {
  const s = String(key);
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function getAvatarGradient(key: string | number): string {
  const [top, bottom] = PEER_COLORS[hashKey(key) % PEER_COLORS.length];
  return `linear-gradient(180deg, ${top} 0%, ${bottom} 100%)`;
}

export function getAvatarInitials(firstName?: string | null, lastName?: string | null): string {
  const f = (firstName || '').trim();
  const l = (lastName || '').trim();
  const first = f ? Array.from(f)[0] : '';
  const second = l ? Array.from(l)[0] : '';
  return (first + second).toUpperCase();
}
